
import tagableMixin from "~/mixins/tagableMixin";

const IMAGE_DIMENSION = "208";

export default {
  mixins: [tagableMixin],

  props: {
    product: { type: Object, default: () => ({}) },
    withPrice: { type: Boolean, default: false },
  },

  computed: {
    tags() {
      return this.product.tags ?? [];
    },

    imageOptions() {
      return {
        src: this.product.image,
        widths: [IMAGE_DIMENSION],
        width: IMAGE_DIMENSION,
        height: IMAGE_DIMENSION,
      };
    },

    selectedVariant() {
      return this.product.selectedVariant || {};
    },

    hasDiscountPrice() {
      return this.hasDiscount(
        this.selectedVariant.compare_at_price,
        this.selectedVariant.price
      );
    },
  },
};
